/**
 * Migalhas do arranque.
 *
 * Dentro do APK não existe console para consultar, e uma tela branca é
 * indistinguível de travamento. Cada etapa do boot deixa uma marca aqui, e a
 * tela de falha mostra a lista: assim dá para ver ONDE parou, em vez de saber
 * apenas que não abriu.
 *
 * Custa uma linha de texto por etapa. Não some em produção de propósito.
 */
const marcas: string[] = [];
const inicio = Date.now();

export function marcarBoot(etapa: string) {
  if (marcas.length > 40) return; // não vira log infinito depois de aberto
  marcas.push(`${String(Date.now() - inicio).padStart(5)}ms  ${etapa}`);
}

export function marcasDoBoot(): string {
  return marcas.length ? marcas.join("\n") : "(nenhuma etapa registrada)";
}
